import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FiltersService } from '@app/shared/services/filters/filters.service';

import { BlockTypeEnum } from '@core/enums';
import { BlockAction } from '@core/models';
import { Block } from '@core/models/block/block.model';
import { ButtonHandlerService } from '@core/services/button-handler.service';

@Component({
  selector: '[special-block]',
  templateUrl: './special-block.component.html',
  styleUrls: ['./special-block.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SpecialBlockComponent {
  blockTypeEnum = BlockTypeEnum;

  @Input() item: Block;
  @Input() action: BlockAction;
  @Input() extraData: any = {};

  // AT-9250: nie ma tu już zarządzania etykietą sortowania. Konstruktor odtwarzał ją
  // z `localStorage` i kasował doraźną pętlą po `optionSelect`, przez co o wyniku
  // decydowała kolejność tworzenia bloków na stronie, a wejście z odnośnika
  // zawierającego `sorting` przy pustym `localStorage` podstawiało `null` i wywalało
  // konstruktory kolejnych bloków. Etykietę wyprowadza teraz z adresu
  // `SortingListComponent`, do którego ta odpowiedzialność należy.
  constructor(public buttonHandlerService: ButtonHandlerService, private fs: FiltersService) {
  }

  isChild(): boolean {
    return !(this.fs.sortingParse && this.fs.sortingParse.length == 0);
  }
}
